/** Login component messages (EN)  */
export default {
  header: {
    welcomeTo: 'Welcome to',
  },
  form: {
    placeholder: {
      email: 'Email',
      password: 'Password',
    },
    button: {
      login: 'Login',
    },
    link: {
      forgotPassword: 'Forgot Password?',
    },
  },
};
